module.exports = __webpack_public_path__ + "img/QQ.22a31129.png";